'use strict';

export function UserTaskMetricsDomainProvider() {
  return {
    $get: ['FirebaseUtil', 'AbstractRelationClass',
      function (FirebaseUtil, AbstractRelationClass) {
        function UserTaskMetricsDomain(data) {
          AbstractRelationClass.call(this, UserTaskMetricsDomain, data);
        }

        AbstractRelationClass.__inheritFrom(UserTaskMetricsDomain, 'UserTaskMetricsDomain');

        UserTaskMetricsDomain.$constraints.addConstraints({
          readComments: {type: 'number', min: 0, defaultValue: 0}
        });

        return UserTaskMetricsDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/auth/domain/user-metrics/UserTaskMetricsDomain.js